import { z } from "zod";

import { CURRENT_LEGAL_AGREEMENT_VERSION } from "../../../constants/legalAgreement";
import { displayNameValidation } from "../../../validation/user";
import { Goal, FoundOn } from "../../firestore/app/users/userDocument";

export const OnboardingPostBodySchema = z.object({
  displayName: displayNameValidation,
  legalAgreementVersion: z.literal(CURRENT_LEGAL_AGREEMENT_VERSION),
  questionnaire: z
    .object({
      goal: z.enum(Goal),
      experience: z.number().min(0).max(100),
      currentRelaxationLevel: z.number().min(0).max(10),
      foundOn: z.enum(FoundOn),
    })
    .optional(),
  userAgreementTracking: z.boolean(),
  newsletterOptIn: z.boolean().optional(),
  newsletterMail: z.email().optional(),
});

// Use z.infer to create a type that matches the Zod schema
export type OnboardingPostBody = z.infer<typeof OnboardingPostBodySchema>;
